module.exports = __webpack_public_path__ + "public/images/partners/sup-4.7e6c4d9a1ebee7cb120888ce4ba6ffb8.png";